import React, { useState, useEffect } from 'react';
import { testSupabaseConnection } from '../utils/connectionUtils';

const CloudflareStatusBanner: React.FC = () => {
  const [isDown, setIsDown] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    // Consecutive-failure counter so a single transient blip (e.g. cold app
    // launch racing the device's network stack) never surfaces the banner.
    // Only a sustained outage across back-to-back checks does.
    let consecutiveFailures = 0;

    const checkStatus = async () => {
      setIsChecking(true);
      // Real retries with backoff (not a single-shot check) before we even
      // count this round as a failure.
      const result = await testSupabaseConnection(3);
      if (result.isCloudflareDown) {
        consecutiveFailures += 1;
      } else {
        consecutiveFailures = 0;
      }
      setIsDown(consecutiveFailures >= 2);
      setIsChecking(false);
    };

    // Check immediately
    checkStatus();

    // Check every 30 seconds
    const interval = setInterval(checkStatus, 30000);

    return () => clearInterval(interval);
  }, []);

  if (!isDown) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: 'white',
        padding: '12px 16px',
        textAlign: 'center',
        zIndex: 10000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        fontSize: '14px',
        fontWeight: '600',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
        <span>⚠️</span>
        <span>Cloudflare service is temporarily unavailable. Your cached data is still available.</span>
      </div>
    </div>
  );
};

export default CloudflareStatusBanner;

